(function () {
  'use strict';

  var ROUTES     = window.routes || {};
  var ADD_URL    = ROUTES.cart_add_url    || '/cart/add.js';
  var CHANGE_URL = ROUTES.cart_change_url || '/cart/change.js';
  var GET_URL    = '/cart.js';
  var _fetch     = window.fetch.bind(window);

  var lastQty = parseInt(localStorage.getItem('ss_cart_qty') || '0', 10) || 0;

  // ---- Native Shopify Ajax Cart API (single source of truth) ----

  function jsonFetch(url, body) {
    var opts = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    if (body) {
      opts.method = 'POST';
      opts.body = JSON.stringify(body);
    }
    return _fetch(url, opts).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          var err = new Error((data && (data.description || data.message)) || 'Cart request failed');
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function getCart() {
    return jsonFetch(GET_URL);
  }

  function changeLine(key, qty) {
    return jsonFetch(CHANGE_URL, { id: key, quantity: qty });
  }

  function removeLine(key) {
    return changeLine(key, 0);
  }

  function refresh() {
    return getCart()
      .then(applyCart)
      .catch(function (err) {
        console.error('[cart-fix]', err);
      });
  }

  // ---- Rendering ----

  function applyCart(cart) {
    lastQty = cart.item_count;
    localStorage.setItem('ss_cart_qty', String(lastQty));
    setBadge(lastQty);
    renderItems(cart.items);
    return cart;
  }

  function setBadge(qty) {
    document
      .querySelectorAll('.cart-bubble__text, #cart-bubble-text')
      .forEach(function (el) {
        el.textContent = qty;
      });
    var badge = document.getElementById('ss-badge');
    if (!badge) {
      var ci = document.querySelector('cart-icon');
      var btn = ci ? ci.closest('button') : null;
      if (btn) {
        if (getComputedStyle(btn).position === 'static') btn.style.position = 'relative';
        btn.style.overflow = 'visible';
        badge = document.createElement('span');
        badge.id = 'ss-badge';
        btn.appendChild(badge);
      }
    }
    if (badge) {
      badge.textContent = qty;
      badge.style.display = qty > 0 ? 'flex' : 'none';
    }
  }

  function fmt(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function imgUrl(src) {
    if (!src) return null;
    return src.indexOf('//') === 0 ? 'https:' + src : src;
  }

  function renderItems(items) {
    var body = document.getElementById('ss-body');
    var footer = document.getElementById('ss-footer');
    if (!body || !footer) return;

    if (!items || items.length === 0) {
      body.innerHTML =
        '<p style="text-align:center;color:#aaa;padding:60px 0 20px;font-size:14px;letter-spacing:.2px">Your cart is empty</p>';
      footer.innerHTML = '';
      return;
    }

    var subtotal = items.reduce(function (s, it) {
      return s + it.final_line_price;
    }, 0);

    body.innerHTML = items
      .map(function (it) {
        var src = imgUrl(it.image);
        var img = src
          ? '<img src="' + src + '" style="width:76px;height:76px;object-fit:cover;border-radius:8px;flex-shrink:0;background:#f5f2ee">'
          : '<div style="width:76px;height:76px;background:#f5f2ee;border-radius:8px;flex-shrink:0"></div>';
        return (
          '<div style="display:flex;gap:14px;padding:16px 0;border-bottom:1px solid #efefef">' +
          img +
          '<div style="flex:1;min-width:0">' +
          '<div style="font-size:13px;font-weight:600;color:#1a1a1a;margin-bottom:3px;line-height:1.35">' +
          it.product_title +
          '</div>' +
          (it.variant_title
            ? '<div style="font-size:11px;color:#aaa;margin-bottom:5px;letter-spacing:.2px;text-transform:uppercase">' +
              it.variant_title +
              '</div>'
            : '') +
          '<div style="font-size:13px;color:#4a5c3a;font-weight:600;margin-bottom:10px">' +
          fmt(it.price) +
          '</div>' +
          '<div style="display:flex;align-items:center;gap:0">' +
          '<div style="display:flex;align-items:center;border:1px solid #ddd;border-radius:6px;overflow:hidden">' +
          '<button data-action="dec" data-key="' +
          it.key +
          '" data-qty="' +
          it.quantity +
          '" style="width:30px;height:28px;border:none;background:#faf9f7;cursor:pointer;font-size:15px;line-height:1;color:#555">&#8722;</button>' +
          '<span style="font-size:13px;min-width:28px;text-align:center;border-left:1px solid #ddd;border-right:1px solid #ddd;height:28px;line-height:28px;background:#fff">' +
          it.quantity +
          '</span>' +
          '<button data-action="inc" data-key="' +
          it.key +
          '" data-qty="' +
          it.quantity +
          '" style="width:30px;height:28px;border:none;background:#faf9f7;cursor:pointer;font-size:15px;line-height:1;color:#555">+</button>' +
          '</div>' +
          '<button data-action="rem" data-key="' +
          it.key +
          '" style="margin-left:auto;background:none;border:none;color:#ccc;cursor:pointer;font-size:20px;padding:4px;line-height:1;flex-shrink:0" title="Remove">&times;</button>' +
          '</div></div></div>'
        );
      })
      .join('');

    footer.innerHTML =
      '<div style="display:flex;justify-content:space-between;align-items:baseline;margin-bottom:6px">' +
      '<span style="font-size:14px;color:#777">Subtotal</span>' +
      '<span style="font-size:17px;font-weight:700;color:#1a1a1a">' +
      fmt(subtotal) +
      '</span>' +
      '</div>' +
      '<p style="font-size:11px;color:#aaa;margin:0 0 16px;text-align:right">Taxes and shipping calculated at checkout</p>' +
      '<a href="/checkout" style="display:block;background:#3d5a3d;color:#fff;text-align:center;padding:15px;border-radius:8px;text-decoration:none;font-weight:700;font-size:14px;letter-spacing:.4px;margin-bottom:10px">Checkout</a>' +
      '<button onclick="ssDrawer.close()" style="display:block;width:100%;background:none;border:1px solid #e0e0e0;padding:13px;border-radius:8px;cursor:pointer;font-size:13px;color:#888;font-family:inherit;text-transform:none;letter-spacing:.2px">Continue Shopping</button>';

    body.onclick = function (e) {
      var btn = e.target.closest('[data-action]');
      if (!btn) return;
      var a = btn.dataset.action,
        key = btn.dataset.key,
        q = parseInt(btn.dataset.qty, 10);
      var op;
      if (a === 'inc') op = changeLine(key, q + 1);
      else if (a === 'dec') op = q <= 1 ? removeLine(key) : changeLine(key, q - 1);
      else if (a === 'rem') op = removeLine(key);
      if (op) {
        op.then(applyCart).catch(function (err) {
          console.error('[cart-fix]', err);
          refresh(); // resync UI with actual server state instead of failing silently
        });
      }
    };
  }

  // ---- Drawer chrome ----

  var ssDrawer = (window.ssDrawer = {
    open: function () {
      if (!document.getElementById('ss-drawer')) buildDrawer();
      document.getElementById('ss-drawer').style.transform = 'translateX(0)';
      document.getElementById('ss-overlay').style.opacity = '1';
      document.getElementById('ss-overlay').style.pointerEvents = 'auto';
      document.body.style.overflow = 'hidden';
      refresh();
    },
    close: function () {
      var d = document.getElementById('ss-drawer'),
        o = document.getElementById('ss-overlay');
      if (d) d.style.transform = 'translateX(100%)';
      if (o) {
        o.style.opacity = '0';
        o.style.pointerEvents = 'none';
      }
      document.body.style.overflow = '';
    },
    isOpen: function () {
      var d = document.getElementById('ss-drawer');
      return !!(d && d.style.transform === 'translateX(0)');
    },
  });

  function buildDrawer() {
    var ov = document.createElement('div');
    ov.id = 'ss-overlay';
    ov.onclick = ssDrawer.close;
    ov.style.cssText =
      'position:fixed;inset:0;background:rgba(0,0,0,.4);z-index:9998;opacity:0;pointer-events:none;transition:opacity .3s';
    document.body.appendChild(ov);
    var d = document.createElement('div');
    d.id = 'ss-drawer';
    d.style.cssText =
      'position:fixed;top:0;right:0;bottom:0;width:100%;max-width:420px;background:#fff;z-index:9999;transform:translateX(100%);transition:transform .3s cubic-bezier(.4,0,.2,1);display:flex;flex-direction:column;font-family:inherit;box-shadow:-8px 0 32px rgba(0,0,0,.08)';
    d.innerHTML =
      '<div style="display:flex;align-items:center;justify-content:space-between;padding:18px 22px;border-bottom:1px solid #efefef;background:#faf9f7;flex-shrink:0">' +
      '<div style="font-size:16px;font-weight:700;color:#1a1a1a;letter-spacing:-.2px">Your Cart</div>' +
      '<button onclick="ssDrawer.close()" style="background:none;border:1px solid #e0e0e0;border-radius:50%;width:32px;height:32px;cursor:pointer;color:#888;font-size:18px;line-height:1;display:flex;align-items:center;justify-content:center;flex-shrink:0">&times;</button>' +
      '</div>' +
      '<div id="ss-body" style="flex:1;overflow-y:auto;padding:0 22px;-webkit-overflow-scrolling:touch"><p style="text-align:center;color:#aaa;padding:60px 0 20px;font-size:14px;letter-spacing:.2px">Your cart is empty</p></div>' +
      '<div id="ss-footer" style="padding:18px 22px;border-top:1px solid #efefef;background:#faf9f7;flex-shrink:0"></div>';
    document.body.appendChild(d);
  }

  // ---- Suppress the theme's native drawer, open ours instead ----

  function patchDrawerProto() {
    var cd = document.querySelector('cart-drawer-component');
    if (!cd) return;
    cd.open = function () {
      ssDrawer.open();
    };
    cd.showDialog = function () {
      ssDrawer.open();
    };
    var proto = Object.getPrototypeOf(cd);
    if (proto) {
      if (typeof proto.open === 'function')
        proto.open = function () {
          ssDrawer.open();
        };
      if (typeof proto.showDialog === 'function')
        proto.showDialog = function () {
          ssDrawer.open();
        };
    }
  }

  function suppressNativeDrawer(cd) {
    var isOpen =
      cd.hasAttribute('open') ||
      cd.classList.contains('active') ||
      cd.classList.contains('open') ||
      cd.classList.contains('is-open') ||
      cd.classList.contains('is-visible') ||
      cd.getAttribute('aria-hidden') === 'false';
    if (!isOpen) return;
    cd.removeAttribute('open');
    cd.setAttribute('aria-hidden', 'true');
    cd.classList.remove('active', 'open', 'is-open', 'is-visible');
    if (typeof cd.close === 'function') cd.close();
    document.body.classList.remove('overflow-hidden', 'no-scroll', 'js-drawer-open', 'cart-open');
    if (!ssDrawer.isOpen()) ssDrawer.open();
  }

  // MutationObserver instead of a requestAnimationFrame loop: only does work when the
  // native drawer's attributes actually change, instead of polling every frame forever.
  function watchThemeDrawer() {
    var cd = document.querySelector('cart-drawer-component');
    if (!cd || cd.dataset.ssObserved) return;
    cd.dataset.ssObserved = '1';
    suppressNativeDrawer(cd);
    new MutationObserver(function () {
      suppressNativeDrawer(cd);
    }).observe(cd, { attributes: true, attributeFilter: ['open', 'class', 'aria-hidden'] });
  }

  document.addEventListener(
    'click',
    function (e) {
      var el = e.target.closest('cart-icon, [data-testid="cart-icon"], .header-actions__action');
      if (el) {
        e.preventDefault();
        e.stopImmediatePropagation();
        ssDrawer.open();
      }
    },
    true
  );

  // Let every /cart/add, /cart/change, /cart/update request hit the REAL Shopify cart
  // exactly as it would without this script. We never rewrite the request or its response —
  // we just piggyback on success to refresh our own drawer + badge from /cart.js, and pop
  // the drawer open after a successful add.
  window.fetch = function (resource, options) {
    var url = typeof resource === 'string' ? resource : resource instanceof Request ? resource.url : String(resource);
    var isCartWrite = /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url);
    var promise = _fetch(resource, options);
    if (isCartWrite) {
      var isAdd = /\/cart\/add/.test(url);
      promise
        .then(function (response) {
          if (!response.ok) return;
          return refresh().then(function () {
            if (isAdd) ssDrawer.open();
          });
        })
        .catch(function () {});
    }
    return promise;
  };

  function init() {
    setBadge(lastQty);
    patchDrawerProto();
    watchThemeDrawer();
    setTimeout(function () {
      patchDrawerProto();
      watchThemeDrawer();
    }, 500);
    setTimeout(function () {
      patchDrawerProto();
      watchThemeDrawer();
    }, 1500);
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  var css = document.createElement('style');
  css.textContent =
    '#ss-badge{position:absolute;top:-6px;right:-6px;background:#4a5c4a;color:#fff;border-radius:50%;' +
    'min-width:18px;height:18px;font-size:11px;font-weight:700;display:none;align-items:center;' +
    'justify-content:center;padding:0 3px;pointer-events:none;z-index:10}';
  document.head.appendChild(css);
})();